import { Component, OnInit, Input, Output, EventEmitter, HostBinding } from '@angular/core';
import { DocFamilyType as ExternalDocFamilyType, ExternalDocument } from 'estensa-module';
import { CultureService } from '../../services/culture.service';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { seUpdateSelectExternalDoc, seAddNewExternalDoc } from '../redux/external-docs.actions';
import { Store } from '@ngrx/store';
import { RootState } from '../../root-store/root.state';

@Component({
    selector: 'se-external-docs-editor',
    templateUrl: './se-external-docs-editor.component.html',
    styleUrls: ['./se-external-docs-editor.component.scss'],
    standalone: false
})
export class SeExternalDocsEditorComponent implements OnInit {
    @HostBinding('class')
    className = 'se-external-docs-editor';

    idReferto = "F12BDCC7-A147-4246-BFFC-83D3730BB991";
    idConsenso = "A2948E0C-5F3E-4FA4-BD57-2BB30133CCB1";
    idAssicurazione = "84C94665-479E-46EE-9224-8D25F7F24E7D";
    idAltro = "B70A8DC4-90D8-4F5E-987A-647FA61B7785";

    @Input()
    isAddingDoc: boolean;

    @Input()
    isEditingDoc: boolean;

    @Input()
    selectedDoc: ExternalDocument;

    @Input()
    selectedDocType?: ExternalDocFamilyType;

    @Output()
    cancelOpsRequired = new EventEmitter();

    @Output()
    confirmOpsRequired = new EventEmitter();

    internalDoc: ExternalDocument;

    constructor(private culture: CultureService,
        private translate: TranslateService,
        private store: Store<RootState>)
    {
    }

    public ngOnInit(): void {
        this.internalDoc = JSON.parse(JSON.stringify(this.selectedDoc));
    }

    public onCancelOps() {
        this.cancelOpsRequired.emit();
    }

    public onConfirmOps() {
        // Se edito c'è un moment che da problemi con la serializzazione del redux, ma lo devo considerare solo
        // se sto lavorando a livello di paziente - a livello di studio il campo non c'è
        if (this.selectedDocType == ExternalDocFamilyType.Patient)
            this.internalDoc.eventDateTime = JSON.parse(JSON.stringify(moment(this.internalDoc.eventDateTime).utc().toDate()));

        if (this.isEditingDoc)
            this.store.dispatch(seUpdateSelectExternalDoc({
                doc: this.internalDoc
            }));
        else
            this.store.dispatch(seAddNewExternalDoc({
                doc: this.internalDoc
            }));
    }

    public canConfirm(docType): boolean {
        if (docType == 0) { // Paziente
            const date = moment(this.internalDoc.eventDateTime);
            return date.isValid();
        }

        return true;
    }
}
